import toast from "react-hot-toast";
import * as api from "../Api";

export const getHeadOfficeAdviceFromBranches = () => async (dispatch) => {
  try {
    const { data } = await api.getHeadOfficeAdviceFromBranches();
    dispatch({ type: "GET_HEAD_OFFICE_ADVICE", payload: data });
  } catch (error) {}
};

export const clearAdvice = (id, postData) => async (dispatch) => {
  let clearingId;
  try {
    clearingId = toast.loading("submitting...");
    await api.updateAdvice(id, postData);
    dispatch({ type: "CLEAR_ADVISE", payload: id });
    toast.remove(clearingId);
    toast.success("data successfully patched");
  } catch (error) {
    toast.remove(clearingId);
    toast.error(error.message);
  }
};
